import { createBusinessComponent } from '../utils/create';
import TjAvatar from '../avatar';
export default createBusinessComponent({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.b(),
      on: {
        "click": _vm.clickFn
      }
    }, [_c('tj-avatar', {
      attrs: {
        "photo-url": _vm.photoUrl,
        "width": _vm.width,
        "height": _vm.height,
        "border-width": _vm.borderWidth,
        "border-color": _vm.borderColor,
        "arc": _vm.arc
      }
    }, [_vm.best ? _c('div', {
      staticClass: "best-icon"
    }) : _vm._e(), _vm.bottomShadow ? _c('div', {
      staticClass: "photo-shadow"
    }) : _vm._e(), _c('div', {
      staticClass: "business-icon-wrap",
      style: _vm.rbaStyleCpd
    }, [_vm.rba ? _c('div', {
      staticClass: "self-business-icon"
    }) : _vm._e()])])], 1);
  },
  name: 'user-avatar',
  components: {
    TjAvatar: TjAvatar
  },
  props: {
    photoUrl: {
      type: String,
      default: null
    },
    width: {
      type: Number,
      default: 50
    },
    height: {
      type: Number,
      default: 50
    },
    borderWidth: {
      type: Number,
      default: 4
    },
    borderColor: {
      type: String,
      default: '#fff'
    },
    arc: {
      type: Boolean,
      default: true
    },
    best: {
      type: Boolean,
      default: false
    },
    rba: {
      type: Boolean,
      default: false
    },
    bottomShadow: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    rbaStyleCpd: function rbaStyleCpd() {
      return {
        left: this.borderWidth + 'px',
        top: this.borderWidth + 'px'
      };
    }
  },
  methods: {
    clickFn: function clickFn() {
      this.$emit('click');
    }
  }
});